import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import createLevitatedMenu from './create-levitated-menu'
import createLockedMenu from './create-locked-menu'
import wobSizeMenu from './wob-size-menu'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import WobDrilldownMenu from 'scoreboard/dashboards/widgets/wob-drilldown-menu'

var WidgetConfig = BootslideMenu.extend({
	configSize: { width: true, height: true },

	allowDuplicate: true,
	allowDrilldown: true,
	allowDynamicWidth: true,

	menu: function () {
		let hasTemplate = this.model.wob.get('hasTemplate')
		// We set wob.locked = true if the wob is copied from a template, so that canvas
		// won't allow it to be moved. So it was only explicitly locked if !hasTemplate
		let explicitlyLocked = this.model.wob.get('locked') && !hasTemplate
		let targets = []

		if (!explicitlyLocked) {
			// if the wob wasn't explicitly locked, let the wob config implementation
			// specify its type-specific config options
			this.typeSpecificTargets(hasTemplate).forEach(t => targets.push(t))

			if (this.allowDrilldown) {
				// Also add drilldown menu to all widget types that allow it.
				// Note that drilldown can be configured even if the widget
				// comes from a template dashboard
				targets.push(WobDrilldownMenu.buildMenu(this, this.canvas, this.widgetUpdater))
			}
		}

		// These options always go at the bottom; they'll be ignored when grouping
		// all menu items by type
		let alwaysLast = []

		if (!hasTemplate) {
			if (!explicitlyLocked) {
				// if the wob wasn't explicitly locked, add in these config options
				// that are common to all widget types
				let sizeMenuOptions = _.extend(
					{ model: this.model },
					_.result(this, 'configSize'))
				targets.push(wobSizeMenu(this.canvas, sizeMenuOptions))
				alwaysLast.push(createLevitatedMenu(this.model, this.canvas))
			}

			alwaysLast.push(createLockedMenu(this.model, this.canvas))

			if (!explicitlyLocked) {
				if (this.allowDuplicate) {
					alwaysLast.push(duplicateTarget(this.canvas))
				}

				alwaysLast.push(BootslideMenu.deleteTarget())
			}
		}

		// #14453 Sort all the top-level targets by type. Within a given type, they will
		// generally use the same order as was returned by this.typeSpecificTargets()
		let sortedTargets = []
		let byType = _.groupBy(targets, 'type')

		function pushAll (targets) {
			_.forEach(targets, t => sortedTargets.push(t))
		}

		pushAll(byType['icons'])
		pushAll(byType['dialog'])
		// #58057 allow displaying a submenu above the value-then-submenu items
		// (ex. allow displaying 'Dataset Options' submenu above 'Font Size'
		// value-then-submenu)
		pushAll(byType['priority-submenu'])
		pushAll(byType['value-then-submenu'])

		let submenuOptions = byType['submenu']
		if (!_.isEmpty(submenuOptions)) {
			// Background and size should always be the last two submenu items
			// (if present)
			let bgMenu = _.remove(submenuOptions, o => o.id === 'background')
			let sizeMenu = _.remove(submenuOptions, o => o.id === 'size')

			pushAll(submenuOptions)
			pushAll(bgMenu)
			pushAll(sizeMenu)
		}

		pushAll(byType['toggle'])

		let unknownTypeOptions = byType[undefined]
		if (!_.isEmpty(unknownTypeOptions)) {
			// If a top-level option wasn't assigned a 'type', log the error, but
			// still put them in the menu so they aren't mysteriously missing
			console.error('widget config menu options missing type:', unknownTypeOptions)
			pushAll(unknownTypeOptions)
		}

		// Add in the common items that should always be last (Locked, Delete, etc)
		pushAll(alwaysLast)

		return {
			label: this.label || 'dashboards.editWidget',
			target: sortedTargets,
			width: this.width || 180 // min-width of 180px if this.width is undefined
		}
	},

	typeSpecificTargets(hasTemplate) {
		return []
	}
})

function duplicateTarget (canvas) {
	return {
		label: i18n.get('common.duplicate'),
		contentView: DuplicateOption.extend({ canvas })
	}
}

var DuplicateOption = Backbone.View.extend({
	className: 'config-duplicate',

	events: {
		'click': 'duplicate'
	},

	render: function () {
		this.$el.html(BootslideMenu.configIconLabel('copy', 'common.duplicate'))
		return this
	},

	duplicate: function (e) {
		e.stopPropagation()
		e.preventDefault()

		// add any accessory wobs to the selection so they are copied over as
		// well
		const accessoryWobs = _(this.canvas.selection.wobs)
			.map(w => w.accessoryWobs || [])
			.flatten()
			.value()
		_.each(accessoryWobs, wob => this.canvas.selection.add(wob))

		this.canvas.selection.copy()
		this.canvas.selection.paste()
	}
})

export default WidgetConfig

WidgetConfig.__filename__ = 'dashboards/widgets/widget-config-menu.js'
